<template>
  <organism-idc-create-edit-customer
    v-model="customerDetail"
    :cardTitle="cardTitle"
    :businessTypeOption="businessTypeOption"
    @onConfirmCreateNewCustomer="onConfirmCreateNewCustomer"
    @onConfirmEditCustomer="onConfirmEditCustomer"
  ></organism-idc-create-edit-customer>
</template>

<script>
import OrganismIdcCreateEditCustomer from "@/components/organisms/portal/internal/idc/OrganismIdcCreateEditCustomer.vue"
import mixins from "@/mixins"
import mixinsValidator from "@/mixins/mixinsValidator"
import {
  createNewCustomer,
  getBusinessTypeList,
  getCustomerDetailById,
  updateCustomerDetail,
} from "@/api/api-module1"
export default {
  name: "IdcCreateEditCustomer",
  components: { OrganismIdcCreateEditCustomer },
  mixins: [mixins, mixinsValidator],
  data() {
    return {
      businessTypeOption: [],
      customerDetail: {},
      editedCustomerDetail: null,
      newCustomerDetail: null,
    }
  },
  computed: {
    customerId() {
      return this.$route?.params?.id
    },
    cardTitle() {
      return this.isEmptyString(this.customerId)
        ? "Create New Customer"
        : "Customer Detail"
    },
  },
  watch: {
    customerId() {
      this.customerDetail.id = this.customerId
    },
  },
  async mounted() {
    await this.getBusinessTypeListFromApi()
    if (this.hasString(this.customerId)) {
      this.customerDetail.id = this.customerId
      await this.getCustomerDetailByIdFromApi()
    }
  },
  methods: {
    onConfirmCreateNewCustomer() {
      this.newCustomerDetail = this.decorateCustomerDetailToCreateApi()
      this.sendRequestCreateNewCustomer()
    },

    onConfirmEditCustomer() {
      this.editedCustomerDetail = this.decorateCustomerDetailToEditApi()
      this.sendRequestUpdateCustomer()
    },

    decorateCustomerDetailToCreateApi() {
      const customerDetailToApiForm = {
        customerName: this.customerDetail.customerName,
        mainAddress: this.getDecoratedAddress("main", "create"),
        billingAddress: this.getDecoratedAddress("billing", "create"),
        mailingAddress: this.getDecoratedAddress("mailing", "create"),
      }
      return customerDetailToApiForm
    },

    decorateCustomerDetailToEditApi() {
      const customerDetailToApiForm = {
        customerName: this.customerDetail.customerName,
        mainAddress: this.getDecoratedAddress("main", "edit"),
        billingAddress: this.getDecoratedAddress("billing", "edit"),
        mailingAddress: this.getDecoratedAddress("mailing", "edit"),
      }
      return customerDetailToApiForm
    },

    getDecoratedAddress(type, caseType) {
      const address = this.customerDetail?.[`${type}Address`]
      if (!address) return null

      const thailand = address?.country?.toLowerCase() === "thailand"
      let decoratedAddress = {
        organizationName: address.organizationName,
        businessTypeId: address.businessType.businessTypeId,
        email: address.email,
        phone: address.phone,
        fax: address.fax,
        country: address.country,
        province: thailand ? address.province.name_th : address.province,
        district: thailand ? address.district.name_th : address.district,
        subDistrict: thailand
          ? address.subDistrict.name_th
          : address.subDistrict,
        address: address.address,
        postalCode:
          caseType === "edit" && thailand
            ? address.postalCode.zip_code
            : address.postalCode,
      }

      if (type === "billing" && address.vat) {
        decoratedAddress = { ...decoratedAddress, vatType: address.vat }
      }

      return decoratedAddress
    },

    navigateTo(path) {
      this.$router.push(path)
    },

    async getBusinessTypeListFromApi() {
      this.showLoading(true)
      await getBusinessTypeList()
        .then((response) => {
          this.businessTypeOption = response.data
        })
        .finally(() => this.showLoading(false))
    },

    async getCustomerDetailByIdFromApi() {
      this.showLoading(true)
      await getCustomerDetailById(this.customerId)
        .then((response) => {
          this.customerDetail = response.data
          this.customerDetail.mainAddress.businessType =
            this.businessTypeOption.find(
              (businessType) =>
                businessType.businessTypeId ===
                this.customerDetail.mainAddress.businessTypeId
            )
          this.customerDetail.billingAddress.businessType =
            this.businessTypeOption.find(
              (businessType) =>
                businessType.businessTypeId ===
                this.customerDetail.billingAddress.businessTypeId
            )
          this.customerDetail.mailingAddress.businessType =
            this.businessTypeOption.find(
              (businessType) =>
                businessType.businessTypeId ===
                this.customerDetail.mailingAddress.businessTypeId
            )
          this.customerDetail.billingAddress.vat =
            this.customerDetail.billingAddress.vatType
        })
        .finally(() => this.showLoading(false))
    },

    async sendRequestCreateNewCustomer() {
      this.showLoading(true)
      await createNewCustomer(this.newCustomerDetail)
        .then((response) => {
          if (response) {
            this.toastSuccess("Create New Customer Successfully")
            this.navigateTo("/internal/web-portal/idc/customer")
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.toastError(error.response.data.ErrorMessage)
          } else {
            this.toastError("Create New Customer Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async sendRequestUpdateCustomer() {
      this.showLoading(true)
      await updateCustomerDetail(
        this.customerDetail.customerId,
        this.editedCustomerDetail
      )
        .then((response) => {
          if (response) {
            this.toastSuccess("Update Successfully")
            this.navigateTo("/internal/web-portal/idc/customer")
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.toastError(error.response.data.ErrorMessage)
          } else {
            this.toastError("Update Customer Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
